import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import clsx from "clsx";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    makeStyles,
    Slide,
    Divider,
    IconButton,
    Fab,
    FormControlLabel,
    Checkbox,
    InputLabel
} from "@material-ui/core";
import {
    VERIFY_ERROR_MESSAGES,
} from "../../utils/constants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from '@material-ui/lab/Alert';
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import InputMask from "react-input-mask";
import { Typography, TextField, Button } from "@packages/ui";
import _ from "lodash";

import * as checkinActions from "src/actions/checkinActions";

import { ThemeProvider } from "react-jss";

import "react-datepicker/dist/react-datepicker.css";
import "react-multi-carousel/lib/styles.css";
import moment from "moment";
import numeral from "numeral";
import { apiURI } from "../../env";

import { theme } from "../../components/ui/theme";
import {
    REGIONS,
    AU_SEARCHADDRESS,
    AU_RETRIEVEADDRESS,
    NZ_SEARCHADDRESS,
    NZ_RETRIEVEADDRESS,
    UK_SEARCHADDRESS,
    UK_RETRIEVEADDRESS,
    CANADA_SEARCHADDRESS,
    CANADA_RETRIEVEADDRESS,
    INTERNATIONAL_SEARCHADDRESS,
    INTERNATIONAL_RETRIEVEADDRESS,
    AddressSuggestionsWhitelist,
} from "../../utils/constants";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import CloseIcon from "@material-ui/icons/Close";
import { WarningRounded } from "@material-ui/icons";
import VerifyError from "./VerifyError";
import SnackBar from "../../layouts/SnackBar";
import * as appActions from "../../actions/appActions";
import getCountryFromURL from "src/utils/getCountryFromUrl";

function StyledCheckbox(props) {
    const classes = useStyles();

    return (
        <Checkbox
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            inputProps={{ "aria-label": "decorative checkbox" }}
            {...props}
        />
    );
}


const AdditionalDriverCheckinForm = () => {
    const classes = useStyles();
    const brand = getBrandFromUrl();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [dialogBox, setDialogBoxOpen] = useState(false);
    const [expiryDateDialogBox, setexpiryDateDialogBox] = useState({
        dialogue: false,
        finalData: {},
    });
    const [letSessionExpire, setLetSessionExpire] = useState(false);
    const [willExpire, setWillExpire] = useState(false);
    const [sessionTracker, setSessionTracker] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [Expand, setExpand] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const [inputValueDownShift, setInputValueDownShift] = useState("");
    const [redirectToVerify, setRedirectToVerify] = useState(false);
    const [newContact, setNewContact] = useState({ email: "", phoneNumber: "" });
    const [verifyFailed, setVerifyFailed] = useState(false);
    const [isInternationalDL, setIsInternationalDL] = useState(false);
    const [noExpiryChecked, setNoExpiryChecked] = useState(false);
    const isDemo = useSelector((state) => state.checkin.isDemo);

    const idVerificationSkipped = useSelector((state) => state.checkin.idVerificationSkipped);
    const checkin = useSelector((state) => state.checkin);
    const idVerification = useSelector((state) => state.checkin.idVerification);
    const customer = useSelector((state) => state.checkin.customer.LatestCustomer);
    // const customerNumber = useSelector((state) => state.checkin.reservation?.Renter.customerNumber);
    const customerNumber = customer?.customerNumber;
    const fromReVerifyID = checkin.requireReVerifyID && !idVerificationSkipped;
    const loadDetailsFromIdvStatus = (fromReVerifyID) || (checkin.idVerification.TransactionId != null && checkin.idVerification.Status != 'PENDING');
    // let firstName, lastName, street, city, postalCode, countryCode, email, phoneNumber, emergencyPhoneNumber, drivingLicence, dob;
    const firstName = loadDetailsFromIdvStatus ? idVerification.FirstName : customer?.RenterName.firstName;
    const lastName = loadDetailsFromIdvStatus ? idVerification.LastName : customer?.RenterName.lastName;
    const licCountry = useSelector((state) => state.checkin.licCountry);
    const street = loadDetailsFromIdvStatus ? idVerification.Address : customer?.Address.Street;
    const city = loadDetailsFromIdvStatus ? idVerification.Suburb : customer?.Address.City;
    const postalCode = loadDetailsFromIdvStatus ? idVerification.PostalCode : customer?.Address.PostalCode;
    const countryCode = loadDetailsFromIdvStatus ? idVerification.StateCountry : customer?.Address.StateOrProvCode;
    const email = loadDetailsFromIdvStatus ? useSelector((state) => state.checkin.reservation.Renter?.Address.Email) : customer?.Address.Email;
    const isNewCustomer = useSelector((state) => state.checkin.customer.LatestCustomer) == null;
    let phoneNumber = loadDetailsFromIdvStatus ? useSelector(
        (state) => state.checkin.reservation.Renter?.Address.HomeTelephoneNumber
    ) : customer?.Address.HomeTelephoneNumber;
    let emergencyPhoneNumber = loadDetailsFromIdvStatus ? useSelector(
        (state) => state.checkin.reservation.Renter?.Address.CellTelephoneNumber
    ) : customer?.Address.CellTelephoneNumber;
    const drivingLicence = loadDetailsFromIdvStatus ? idVerification.LicNo : customer?.DrivingLicence;
    let dob = loadDetailsFromIdvStatus ? idVerification.DOB : customer?.BirthDate;
    let expiry = loadDetailsFromIdvStatus ? idVerification.DateOfExpiry : customer?.DrivingLicence.ExpiryDate;
    const verifiedTime = useSelector((state) => state.checkin.idVerification?.VerifiedTime);
    const regionOfIssueCode = loadDetailsFromIdvStatus ? idVerification.StateOfIssue : customer?.DrivingLicence.Issuer;


    let DNR = false;
    const LocationAddress = checkin?.details.Pickup
        ? _.get(checkin, "details.Pickup[0].address1", "") +
        " " +
        _.get(checkin, "details.Pickup[0].address2", "") +
        " " +
        _.get(checkin, "details.Pickup[0].address3", "") +
        " " +
        _.get(checkin, "details.Pickup[0].city", "") +
        " " +
        _.get(checkin, "details.Pickup[0].postCode", "")
        : " ";
    const reservationNumber = useMemo(() => {
        return checkin.resNo;
    }, [checkin.resNo]);
    const randomNumber = useMemo(() => {
        return Math.random();
    }, [checkin.resNo]);
    const countryCodesAU = ["WA", "VI", "TS", "SA", "QL", "NT", "NS", "AC"];

    if (_.has(checkin, "reservation.Renter")) {
        DNR = checkin?.customer?.DNR;
    }

    // const currentMainNote = _.get(checkin, "reservation.ReservationMainNote", "");
    // const newNote = currentMainNote.slice(0, currentMainNote.indexOf('|CI')) + "|CIP";


    useEffect(() => {
        if (!_.isEmpty(checkin.idVerification.failReasons)) {
            setVerifyFailed(true);
            const error = checkin.idVerification.failReasons;
            const e = VERIFY_ERROR_MESSAGES.find(item => item.error == error[0]);
            dispatch(
                appActions.createToast({
                    type: "failError",
                    message: e.message,
                })
            );
            if (customerNumber != null) {
                //If exisiting customer failed the ocrlabs
                dispatch(
                    checkinActions.updateCustomer({
                        CustomerNumber: checkin.customer.LatestCustomer.customerNumber,
                        brand: brand,
                        data: {
                            scanDocPass: false,
                            verifiedTime
                        },
                        idVerificationSkipped: idVerificationSkipped,
                        isAdditionalDriver: true,
                        token: checkin.auth.token,
                        country: checkin.country,
                    })
                )

            }
        } else {
            setVerifyFailed(false);
        }
    }, [checkin.idVerification]);


    useEffect(() => {
        // New customer who just passed id verificatiion, page redirected to chekin-form.

        if (loadDetailsFromIdvStatus) {

            dispatch(checkinActions.requestIdVerificationStatus({ token: checkin.auth.token, transactionId: checkin.idVerification.TransactionId }));
        }
    }, []);

    useEffect(() => {
        const suggestionCountry = _.get(getValues("countryCode"), "value", "");

        if (countryCodesAU.includes(suggestionCountry)) {
            setSuggestions(
                _.filter(_.get(checkin, "addressSuggestions", []), function (o) {
                    return _.includes(o.label, suggestionCountry);
                })
            );
        } else {
            setSuggestions(checkin.addressSuggestions);
        }
    }, [checkin.addressSuggestions]);

    useEffect(() => {
        const suggestionCountry = _.get(getValues("countryCode"), "value", "");

        if (countryCodesAU.includes(suggestionCountry)) {
            setSuggestions(
                _.filter(_.get(checkin, "addressSuggestions", []), function (o) {
                    return _.includes(o.label, suggestionCountry);
                })
            );
        } else {
            setSuggestions(checkin.addressSuggestions);
        }
    }, [checkin.Renter]);

    if (_.has(checkin, "customer.DNR")) {
        DNR = checkin?.customer?.DNR;
    }

    expiry = expiry != null ? moment(expiry).format("DD/MM/YYYY") : null;

    // const isDisableDob = !_.isEmpty(dob);
    // const isDisableExpiry = !_.isEmpty(expiry);

    const isDisableFirstName = !_.isEmpty(firstName);
    const isDisableLastName = !_.isEmpty(lastName);
    const isDisableDriverLicenceNumber = !_.isEmpty(drivingLicence);
    const isDisableIssuer = !_.isEmpty(regionOfIssueCode);



    dob = moment(dob).format("DD/MM/YYYY");


    const country = countryCode != null ? REGIONS.filter((code) => code.value == countryCode) : null;
    const regionOfIssue =
        regionOfIssueCode != null ? REGIONS.filter((code) => code.value == regionOfIssueCode) : null;



    if (!_.isEmpty(phoneNumber)) {
        phoneNumber = phoneNumber.includes("++") ? "+" + phoneNumber.split("++")[1] : phoneNumber;
    }

    if (!_.isEmpty(emergencyPhoneNumber)) {
        emergencyPhoneNumber = emergencyPhoneNumber.includes("++")
            ? "+" + emergencyPhoneNumber.split("++")[1]
            : emergencyPhoneNumber;
    }

    let street1 = "";
    let street2 = "";
    let unitNumber = "";

    if (_.isArray(street)) {
        street1 = street[0];
        street2 = street[1];
    } else if (street != undefined) {
        const first30char = street.slice(0, 30);
        if (first30char[29] == ' ') {
            street1 = street.slice(0, 30).trim()
            street2 = street.slice(30, 60)
        } else {
            const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
            street1 = street.slice(0, street.lastIndexOf(breakingChar));
            street2 = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
        }

    }

    if (street1.includes("undefined")) {
        street1 = "";
    }
    if (street2.includes("undefined")) {
        street2 = "";
    }

    let isStreet2IncludesUnitNumber;

    if (!_.isEmpty(street2)) {
        isStreet2IncludesUnitNumber = street2.includes("-");
    }

    if (isStreet2IncludesUnitNumber) {
        unitNumber = street2.split("-")[0];
        street2 = street2.split("-")[1];
    }
    if (!_.isEmpty(street1)) {
        street2 = street1 + ", " + street2;
    }

    const validattionSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        contactNumber: Yup.string()
            .required("Required")
            .max(15, "Contact Number must be less then 15 numbers ")
            .matches(
                /^[1-9]{1}[0-9]{7,11}$/,
                "Please Enter mobile number in countrycode followed by mobile number format"
            ),
        emergencyContactNumber: Yup.string().test(
            "contact Number match",
            "Please use different emergency contact Number",
            function (value) {
                return this.parent.contactNumber != value;
            }
        ),
        email: Yup.string().email().required("Required"),
        street2: Yup.string().required("Required"),
        city: Yup.string().required("Required"),
        countryCode: Yup.object().required("Required"),
        dob: Yup.string()
            .required("Required")
            .matches(
                /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
                "Please Enter Date in dd/mm/yyyy Format"
            )
            .test("dob", "You must be 18 years old", function (birthdate) {
                const cutoff = new Date();
                cutoff.setFullYear(cutoff.getFullYear() - 18);
                const dob = new Date(moment(birthdate, "DD/MM/YYYY").format("YYYY-MM-DD"));
                return dob <= cutoff;
            })
            .test("dob", "You must be less than 100 years", function (birthdate) {
                const limit = new Date();
                limit.setFullYear(limit.getFullYear() - 100);
                const bd = new Date(moment(birthdate, "DD/MM/YYYY").format("YYYY-MM-DD"));
                return bd > limit;
            }),
        licenceNo: Yup.string()
            .required("Required")
            .matches(/^[a-zA-Z0-9-]*$/, "Licence Number should only have Letters, Numbers, Hyphen")
            .max(20, "Driving Licence should not have more than 20 characters"),
        expiry: Yup.string()
            .matches(
                /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
                { message: "Please Enter Date in dd/mm/yyyy Format", excludeEmptyString: true }
            )
            .test("expiry", "Please enter valid expiry date", function (expiry) {
                if (expiry) {
                    const date = new Date();
                    const expiryDate = new Date(moment(expiry, "DD/MM/YYYY").format("YYYY-MM-DD"));
                    return expiryDate > date;
                } else {
                    return true;
                }
            }),
        // regionOfIssue: Yup.string().required("Required"),
        regionOfIssue: Yup.object().required("Required"),
    });





    const {
        handleSubmit,
        control,
        setValue,
        getValues,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validattionSchema),
        defaultValues: {
            firstName: firstName ? firstName : "",
            lastName: lastName ? lastName : "",
            contactNumber: _.isEmpty(phoneNumber)
                ? " "
                : phoneNumber.includes("+")
                    ? phoneNumber.split("+")[1]
                    : phoneNumber,
            emergencyContactNumber: _.isEmpty(emergencyPhoneNumber)
                ? ""
                : emergencyPhoneNumber.includes("+")
                    ? emergencyPhoneNumber.split("+")[1]
                    : emergencyPhoneNumber,
            email: email ? email : "",
            street2: street2 ? street2 : "",
            city: city ? city : "",
            countryCode: countryCode ? country[0] : "",
            unitNumber: unitNumber ? unitNumber : "",
            postalCode: postalCode ? postalCode : "",
            dob: dob ? dob : "",
            licenceNo: drivingLicence?.Number ? drivingLicence.Number : "",
            expiry: expiry ? expiry : "",
            regionOfIssue: regionOfIssueCode ? regionOfIssue[0] : "",
            // regionOfIssue: _.isEmpty(regionOfIssue)
            //   ? ""
            //   : regionOfIssue[0]?.label
            //     ? regionOfIssue[0]?.label
            //     : "",
            Suburb: "",
        },
    });




    useEffect(() => {
        setInputValueDownShift(street2 ? street2 : "");
        dispatch(checkinActions.setRequireReVerifyCC({ requireReVerifyCC: false }));
    }, []);

    useEffect(() => {
        if (_.has(checkin, 'selectedAddress.address.AddressLine')) {
            if (_.get(checkin, 'selectedAddress.selectedCountry') != 'AU' || _.get(checkin, 'selectedAddress.selectedCountry') != 'NZ') {
                const addressLine1 = checkin.selectedAddress.address.AddressLine1 ?? " ";
                const addressLine2 = checkin.selectedAddress.address.AddressLine2 ?? " ";
                setInputValueDownShift(addressLine1 + ',' + addressLine2)
                setValue("street2", addressLine1 + ',' + addressLine2)
                setValue("city", checkin.selectedAddress.address.LocalityCityTown)
                setValue("postalCode", checkin.selectedAddress.address.Postcode)
            }
            if (_.get(checkin, 'selectedAddress.selectedCountry') == 'AU') {
                setInputValueDownShift(checkin.selectedAddress.address.AddressLine)
                setValue("street2", checkin.selectedAddress.address.AddressLine)
                setValue("city", checkin.selectedAddress.address.Locality)
                setValue("postalCode", checkin.selectedAddress.address.Postcode)
            }
            else if (_.get(checkin, 'selectedAddress.selectedCountry') == 'NZ') {
                const Suburb = checkin.selectedAddress.address.Suburb != "" ? ", " + checkin.selectedAddress.address.Suburb : "";
                setInputValueDownShift(checkin.selectedAddress.address.AddressLine + Suburb)
                setValue("street2", checkin.selectedAddress.address.AddressLine + checkin.selectedAddress.address.Suburb == "" ? "" : " " + checkin.selectedAddress.address.Suburb)
                setValue("city", checkin.selectedAddress.address.TownCityMailtown)
                setValue("postalCode", checkin.selectedAddress.address.Postcode)
            }

        }
    }, [checkin.selectedAddress.address])






    const myRef = useRef(null);

    const Countries = _.sortBy(REGIONS, ["label"]);

    const options = Countries.map((option) => {
        const countryFirstLetter = option.country[0].toLocaleUpperCase();
        return {
            countryFirstLetter: countryFirstLetter,
            ...option,
        };
    });

    useEffect(() => {
        if (checkin?.additionalDriverVoidCompleted == true && !verifyFailed) {
            navigate(`/${isDemo ? 'additional-driver-checkin-demo' : 'additional-driver-checkin'}/checkin-summary`);
        }
    }, [checkin.additionalDriverVoidCompleted]);

    useEffect(() => {
        setLetSessionExpire(false);
        clearInterval(sessionTracker);
        setSessionTracker(
            setInterval(() => {
                const sessionExpiry = _.get(checkin, "auth.expires", moment().subtract(0, "m").unix());
                if (moment().isAfter(moment.unix(sessionExpiry))) {
                    window.location.replace(`/${isDemo ? 'checkin-demo' : 'additional-driver-checkin'}/login`);
                }
                const isExpiring = moment().add(2, "m").isAfter(moment.unix(sessionExpiry));
                setWillExpire(isExpiring);
            }, 10000)
        );
        setWillExpire(false);
    }, [checkin.auth.expires]);


    const [values, setValues] = React.useState(countryCode ? country[0] : "");
    const [inputValue, setInputValue] = React.useState("");

    const placeholder = "DD/MM/YYYY";
    const formatChars = {
        n: "[0-3]",
        m: "[0-9]",
        e: "[0-1]",
        d: "[0-9]",
        z: "[1-2]",
        y: "[0-9]",
    };

    // Get customer details from idverification query transaction, and load values into form fields
    useEffect(() => {

        if (checkin.idVerification.TransactionStatus != undefined) {

            const stateOfIssueCode = checkin.idVerification.StateOfIssue;
            const addressStateCode = checkin.idVerification.StateCountry;
            let addressLine = street.slice(0, street.indexOf(city)).trim();

            if (addressLine.length > 30) {
                let streetOne, streetTwo

                const first30char = street.slice(0, 30);
                if (first30char[29] == ' ') {
                    streetOne = street.slice(0, 30).trim()
                    streetTwo = street.slice(30, 60)
                } else {
                    const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
                    streetOne = street.slice(0, street.lastIndexOf(breakingChar));
                    streetTwo = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
                }
                addressLine = streetOne + ',' + streetTwo

            }

            const addressState = REGIONS.filter((code) => code.value == addressStateCode);
            const regionOfIssue = REGIONS.filter((code) => code.value == stateOfIssueCode);
            if (regionOfIssue.length && !["AUSTRALIA", "NEW ZEALAND"].includes(regionOfIssue[0].country)) {
                setIsInternationalDL(true);
            } else {
                setIsInternationalDL(false);
            }

            setInputValueDownShift(addressLine);

            setValue(
                "firstName", firstName
            );

            setValue(
                "lastName", lastName
            );

            setValue(
                "city", city
            );

            setValue(
                "licenceNo", drivingLicence
            );
            setValue(
                "expiry", expiry
            );
            setValue(
                "postalCode", postalCode
            );

            setValue(
                "dob", dob
            );

            setValue(
                "street2", addressLine
            );


            setValue(
                "countryCode", addressState[0],
            );

            setValue(
                "regionOfIssue", regionOfIssue[0],
            );

        }

    }, [regionOfIssueCode, countryCode]);

    const handleClose = () => {
        dispatch(checkinActions.logout());
        // Token empty set false
        setDialogBoxOpen(false);
    };

    const handleDialogeClose = () => {
        // console.log(expiryDateDialogBox.dialogue);
        setexpiryDateDialogBox({ dialogue: false });
        dispatch(
            checkinActions.updateReservationAndCustomer({
                resno: checkin.resNo,
                // MainNote: newNote,
                CustomerNumber: checkin?.customer?.LatestCustomer?.customerNumber,
                name:
                    checkin.reservation.Renter?.RenterName.firstName +
                    " " +
                    checkin.reservation.Renter?.RenterName.lastName,
                brand: brand,
                total: numeral(_.get(checkin, "estimate.Estimate.Total", 0)).format("0,0.00"),
                confNo: _.isEmpty(checkin.confNo) ? "--" : checkin.confNo,
                pickupDate: moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
                    "DD-MMM-YY"
                ),
                pickupTime: moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
                    "LT"
                ),
                pickupLocation: checkin?.details?.Pickup ? checkin.details.Pickup[0].locationName : "",
                locationAddress: LocationAddress,
                date: `${moment().format("LLL")} AEST`,
                estimate: estimatecharges,
                data: expiryDateDialogBox.finalData,
                otherid: _.get(checkin, "OtherID", ""),
                token: checkin.auth.token,
                country: checkin.country,
                prepaid: checkin.PrePaid,
            })
        );
    };

    const onExtendSession = () => {
        dispatch(checkinActions.extendSession());
    };


    const onSubmit = (data) => {
        if (DNR) {
            setDialogBoxOpen(true);
        } else {
            const countryCode = data.countryCode.value;
            const regionOfIssue = data.regionOfIssue.value;
            const contactNumber = data.contactNumber.includes("+")
                ? data.contactNumber
                : "+" + data.contactNumber;
            const emergencyContactNumber = data.emergencyContactNumber.includes("+")
                ? data.emergencyContactNumber
                : _.isEmpty(data.emergencyContactNumber)
                    ? " "
                    : "+" + data.emergencyContactNumber;
            // regionOfIssue = REGIONS.filter((code) => code.label == regionOfIssue);
            // regionOfIssue = regionOfIssue[0].value;
            const isSplitStreet = data.street2.includes(",");
            let street1 = "";
            let street2 = "";
            if (isSplitStreet) {
                street1 = data.street2.split(",")[0];
                street2 = data.street2.split(",")[1].trim();
            } else if (data.street2.length > 30) {
                const street = data.street2;
                const first30char = street.slice(0, 30);
                if (first30char[29] == ' ') {
                    street1 = street.slice(0, 30).trim()
                    street2 = street.slice(30, 60)
                } else {
                    const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
                    street1 = street.slice(0, street.lastIndexOf(breakingChar));
                    street2 = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
                }
            } else {
                street2 = data.street2.trim();
            }
            if (data.unitNumber != "") {
                street1 = data.unitNumber + "-" + street1;
            }
            data = {
                ...data,
                regionOfIssue,
                countryCode,
                street1,
                street2,
                contactNumber: contactNumber ?? "",
                emergencyContactNumber: emergencyContactNumber ?? "",
                verifiedTime,
                scanDocPass: !loadDetailsFromIdvStatus && idVerificationSkipped ? false : true
            };
            const returnDate = moment(
                checkin?.reservation?.Return?.dateTime,
                "YYYY-MM-DDTh:mm:ss"
            ).format("MM-DD-YYYY");

            // if return customers contact details was edited
            if (customerNumber != null && checkin.verifyCC && checkin.verifyID && !fromReVerifyID) {
                if ((email != null && !data.email.includes(email))) {

                    console.log('email or phone NO changed');
                    setRedirectToVerify(true);
                    setNewContact({ email: data.email, phoneNumber: data.contactNumber })
                    return
                } else if (phoneNumber != null && phoneNumber != 'NULL') {
                    if (data.contactNumber.slice(-5) != phoneNumber.slice(-5)) {
                        setRedirectToVerify(true);
                        setNewContact({ email: data.email, phoneNumber: data.contactNumber })
                        return
                    }
                }
            }

            if (new Date(returnDate) > new Date(moment(data.expiry, "DD/MM/YYYY").format("MM-DD-YYYY"))) {
                const finalData = data;
                setexpiryDateDialogBox({ dialogue: true, finalData: finalData });
            } else {
                if (isNewCustomer) {
                    dispatch(
                        checkinActions.createNewCustomer({
                            resno: checkin.resNo,
                            // CustomerNumber: checkin?.customer?.LatestCustomer?.customerNumber,
                            name:
                                checkin.reservation.Renter?.RenterName.firstName +
                                " " +
                                checkin.reservation.Renter?.RenterName.lastName,
                            brand: brand,
                            data: data,
                            token: checkin.auth.token,
                            country: checkin.country,
                            idVerificationSkipped: !loadDetailsFromIdvStatus && idVerificationSkipped
                        })
                    );
                } else {
                    dispatch(
                        checkinActions.updateCustomer({
                            resno: checkin.resNo,
                            isAdditionalDriver: true,
                            CustomerNumber: checkin.customer.LatestCustomer.customerNumber,
                            name:
                                checkin.reservation.Renter?.RenterName.firstName +
                                " " +
                                checkin.reservation.Renter?.RenterName.lastName,
                            brand: brand,
                            data: data,
                            token: checkin.auth.token,
                            country: checkin.country,
                            idVerificationSkipped: !loadDetailsFromIdvStatus && idVerificationSkipped
                        })
                    );
                }
            }
        }
    };

    useEffect(() => {
        if (loadDetailsFromIdvStatus && !checkin.idVerification.fetchingIdvStatus && checkin.idVerification.TransactionStatus == "COMPLETED_PASS") {
            const addressLine = street.slice(0, street.indexOf(city)).trim();
            let streetOne = "";
            let streetTwo = addressLine;
            if (addressLine.length > 30) {
                const first30char = street.slice(0, 30);
                if (first30char[29] == ' ') {
                    streetOne = street.slice(0, 30).trim()
                    streetTwo = street.slice(30, 60)
                } else {
                    const breakingChar = first30char.slice(first30char.lastIndexOf(' '))
                    streetOne = street.slice(0, street.lastIndexOf(breakingChar));
                    streetTwo = street.slice(street.lastIndexOf(breakingChar)).slice(0, 30)
                }
            }

            const data = {
                countryCode,
                firstName,
                lastName,
                dob,
                postalCode,
                city,
                street1: streetOne,
                street2: streetTwo,
                licenceNo: drivingLicence,
                regionOfIssue: regionOfIssueCode,
                expiry,
                verifiedTime,
                scanDocPass: true,
            }


            if (isNewCustomer) {
                dispatch(
                    checkinActions.manualCreateNewCustomer({
                        resno: checkin.resNo,
                        // CustomerNumber: checkin?.customer?.LatestCustomer?.customerNumber,
                        name:
                            checkin.reservation.Renter?.RenterName.firstName +
                            " " +
                            checkin.reservation.Renter?.RenterName.lastName,
                        brand: brand,
                        data: data,
                        token: checkin.auth.token,
                        country: checkin.country,
                    })
                );
            } else {
                dispatch(
                    checkinActions.manualUpdateCustomer({
                        resno: checkin.resNo,
                        CustomerNumber: checkin.customer.LatestCustomer.customerNumber,
                        name:
                            checkin.reservation.Renter?.RenterName.firstName +
                            " " +
                            checkin.reservation.Renter?.RenterName.lastName,
                        brand: brand,
                        data: data,
                        token: checkin.auth.token,
                        country: checkin.country,
                    })
                );
            }
        }
    }, [checkin.idVerification]);

    const handleClickedSubmit = () => {
        const err = Object.keys(errors);
        // console.log(err)
        if (err.length) {
            const input = document.querySelector(
                `#${err[0]}`
            );

            if (!_.isEmpty(input)) {
                input.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'start',
                });
            }
        }
    }

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    const handleAddressChange = (e) => {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };

        if (e?.target?.value?.length > 4 && e?.target?.value?.length % 4 == 0) {
            // console.log(_.get(getValues("countryCode"), "value", ""));
            if (AddressSuggestionsWhitelist.includes(_.get(getValues("countryCode"), "value", ""))) {
                dispatch(
                    checkinActions.searchAddress({
                        token: checkin.auth.token,
                        address: e.target.value,
                        countryCode: getValues("countryCode").value
                            ? countryCodesAU.includes(getValues("countryCode").value)
                                ? "AU"
                                : getValues("countryCode").value
                            : "AU",
                        method:
                            _.get(getValues("countryCode"), "value", "") == "NZ"
                                ? NZ_SEARCHADDRESS
                                : _.get(getValues("countryCode"), "value", "") == "GB"
                                    ? UK_SEARCHADDRESS
                                    : _.get(getValues("countryCode"), "value", "") == "CA"
                                        ? CANADA_SEARCHADDRESS
                                        : _.has(getValues("countryCode"), "value") &&
                                            countryCodesAU.includes(_.get(getValues("countryCode"), "value", "")) != true
                                            ? INTERNATIONAL_SEARCHADDRESS
                                            : AU_SEARCHADDRESS,
                    })
                );
            }
        }
    };

    const selectedAddress = (data) => {
        dispatch(
            checkinActions.retrieveAddress({
                token: checkin.auth.token,
                countryCode: getValues("countryCode").value
                    ? countryCodesAU.includes(getValues("countryCode").value)
                        ? "AU"
                        : getValues("countryCode").value
                    : "AU",
                method:
                    _.get(getValues("countryCode"), "value", "") == "NZ"
                        ? NZ_RETRIEVEADDRESS
                        : _.get(getValues("countryCode"), "value", "") == "GB"
                            ? UK_RETRIEVEADDRESS
                            : _.get(getValues("countryCode"), "value", "") == "CA"
                                ? CANADA_RETRIEVEADDRESS
                                : _.has(getValues("countryCode"), "value") &&
                                    countryCodesAU.includes(_.get(getValues("countryCode"), "value", "")) != true
                                    ? INTERNATIONAL_RETRIEVEADDRESS
                                    : AU_RETRIEVEADDRESS,
                recordId: data.value,
            })
        );
    };

    const handleConfirmRedirectToVerify = () => {
        dispatch(checkinActions.setRequireReVerifyCC({ requireReVerifyCC: true }));
        dispatch(checkinActions.setRequireReVerifyID({ requireReVerifyID: true }));
        dispatch(checkinActions.resetVerifyStatus());
        dispatch(checkinActions.updateCustomerContact(newContact));


        // navigate("/checkin/verify", { replace: true })
        navigate(`/${isDemo ? 'checkin-demo' : 'checkin'}/privacy/${brand.toLowerCase()}`, { replace: true });

    }
    const getFutureDate = () => {
        const futureDate = new Date();
        futureDate.setFullYear(futureDate.getFullYear() + 2);
        return moment(futureDate).format("DD/MM/YYYY");
    };

    const handleCheckboxChange = (e, onChange) => {
        const isChecked = e.target.checked;
        const newValue = isChecked ? getFutureDate() : expiry || "";
        setNoExpiryChecked(isChecked)
        onChange(newValue);
    };


    return (
        (checkin.loading || checkin.idVerification.fetchingIdvStatus) ? (<Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            // open={true}
            BackdropComponent={Backdrop}
        >
            <Fade in={true}>
                {/* <div style={{ textAlign: "center" }}> */}
                    <React.Fragment>
                        <div style={{ textAlign: "center" }}>
                            <CircularProgress />
                            <div><p>{checkin.idVerification.fetchingIdvStatus ? 'Loading your details...\nThis could take 1 -2 minutes' : 'Submitting'}</p></div>
                        </div>
                    </React.Fragment>
                {/* </div> */}
            </Fade>
        </Modal>) : (verifyFailed ? <VerifyError /> : <div>
            <SnackBar />
            <ThemeProvider theme={theme} className={classes.removeContainer}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ marginTop: 20 }}
                >
                    <Grid item xs={12} lg={8} md={10} style={{ marginTop: 0 }}>
                        <Accordion
                            className={classes.accordion}
                            expanded={true}
                            onChange={() => setExpanded(!expanded)}
                            ref={myRef}
                        >
                            <AccordionSummary
                                aria-controls={`panel1a-content`}
                                id={`panel1a-header`}
                                className={classes.summary}
                            >
                                <Typography className={classes.headerFont} variant={"h3"}>
                                    Personal Information
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container direction="row" justify="center" alignItems="center" spacing={1}>
                                    <Grid item xs={12} style={{ marginTop: 20, marginBottom: 10 }}>
                                        <Typography variant={"h3"}>
                                            Driver Information (Full License Required)
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            control={control}
                                            name="firstName"
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    required
                                                    fullWidth
                                                    id="firstName"
                                                    name="firstName"
                                                    label="First Name"
                                                    disabled={isDisableFirstName}
                                                    value={value}
                                                    error={errors.firstName ? true : false}
                                                    onChange={onChange}
                                                    helperText={errors.firstName ? errors.firstName.message : null}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            control={control}
                                            name="lastName"
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    required
                                                    fullWidth
                                                    id="lastName"
                                                    name="lastName"
                                                    label="Last Name"
                                                    disabled={isDisableLastName}
                                                    value={value}
                                                    error={errors.lastName ? true : false}
                                                    onChange={onChange}
                                                    helperText={errors.lastName ? errors.lastName.message : null}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            control={control}
                                            name="email"
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    inputProps={{
                                                        autoComplete: "new-password",
                                                    }}
                                                    required
                                                    fullWidth
                                                    id="email"
                                                    name="email"
                                                    label="Email"
                                                    value={value}
                                                    error={errors.email ? true : false}
                                                    onChange={onChange}
                                                    helperText={errors.email ? errors.email.message : null}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4} id="contactNumber">
                                        <Controller
                                            control={control}
                                            name="contactNumber"
                                            render={({ field: { onChange, value } }) => (
                                                <PhoneInput
                                                    value={value}
                                                    preferredCountries={["au", "nz"]}
                                                    placeholder={"+61"}
                                                    country={"au"}
                                                    inputStyle={{ width: "100%" }}
                                                    name="contactNumber"
                                                    id="contactNumber"
                                                    specialLabel="Mobile/Phone Number *"
                                                    error={errors.contactNumber ? true : false}
                                                    helperText={errors.contactNumber ? errors.contactNumber.message : null}
                                                    onChange={onChange}
                                                />
                                            )}
                                        />
                                        {errors.contactNumber && (
                                            <p
                                                style={{
                                                    color: "#f44336",
                                                    fontSize: "0.75rem",
                                                    marginLeft: "14px",
                                                    marginRight: "14px",
                                                }}
                                            >
                                                {errors.contactNumber.message}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            control={control}
                                            name="emergencyContactNumber"
                                            render={({ field: { onChange, value } }) => (
                                                <PhoneInput
                                                    value={value}
                                                    preferredCountries={["au", "nz"]}
                                                    placeholder={"+61"}
                                                    country={"au"}
                                                    inputStyle={{ width: "100%" }}
                                                    name="emergencyContactNumber"
                                                    id="emergencyContactNumber"
                                                    specialLabel="Emergency Contact Number"
                                                    error={errors.emergencyContactNumber ? true : false}
                                                    helperText={
                                                        errors.emergencyContactNumber
                                                            ? errors.emergencyContactNumber.message
                                                            : null
                                                    }
                                                    onChange={onChange}
                                                />
                                            )}
                                        />
                                        {errors.emergencyContactNumber && (
                                            <p
                                                style={{
                                                    color: "#f44336",
                                                    fontSize: "0.75rem",
                                                    marginLeft: "14px",
                                                    marginRight: "14px",
                                                }}
                                            >
                                                {errors.emergencyContactNumber.message}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                                        <Typography variant={"h3"}>Address</Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <Alert style={{ marginTop: 15 }} severity="warning">Please select State/Country, for better suggestions in address lookup</Alert>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Controller
                                            name="countryCode"
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                                <Autocomplete
                                                    options={options
                                                        .sort(
                                                            (a, b) => -b.countryFirstLetter.localeCompare(a.countryFirstLetter)
                                                        )
                                                        .sort()}
                                                    groupBy={(option) => option.country}
                                                    value={value}
                                                    // defaultValue={options.find((element) => element.label == value.label)}
                                                    onChange={(_, newValue) => {
                                                        setValues(newValue);
                                                        setValue("countryCode", newValue);
                                                    }}
                                                    // inputValue={inputValue}
                                                    onInputChange={(_, newInputValue) => {
                                                        setInputValue(newInputValue);
                                                    }}
                                                    inputProps={{
                                                        autoComplete: "new-password",
                                                        form: {
                                                            autocomplete: "off",
                                                        },
                                                    }}
                                                    getOptionLabel={(option) => (option.label ? option.label : "")}
                                                    getOptionSelected={(option) => value}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            autoComplete="new-password"
                                                            inputProps={{
                                                                autoComplete: "new-password",
                                                                form: {
                                                                    autocomplete: "off",
                                                                },
                                                            }}
                                                            error={errors.countryCode ? true : false}
                                                            helperText={errors.countryCode ? "Required" : null}
                                                            {...params}
                                                            label="State/Country"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={8} id="street2">
                                        <Controller
                                            name="street2"
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                                <Autocomplete
                                                    freeSolo
                                                    filterOptions={(options, state) => options}
                                                    disableClearable
                                                    options={inputValueDownShift.length > 4 ? suggestions : []}
                                                    inputValue={inputValueDownShift}
                                                    getOptionLabel={(option) =>
                                                        _.isObject(option) ? option.label : option ? option : ""
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            inputProps={{
                                                                autoComplete: "new-password",
                                                            }}
                                                            {...params}
                                                            label="Address Lookup"
                                                            variant="outlined"
                                                            required
                                                        />
                                                    )}
                                                    onInputChange={(value) => {
                                                        handleAddressChange(value);
                                                        setInputValueDownShift(_.get(value, "target.value", ""));

                                                    }}
                                                    onChange={(_, data) => {
                                                        selectedAddress(data);
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            name="city"
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    required
                                                    fullWidth
                                                    inputProps={{
                                                        autoComplete: "new-password",
                                                    }}
                                                    id="city"
                                                    name="city"
                                                    label="City/Suburb"
                                                    value={value}
                                                    error={errors.city ? true : false}
                                                    onChange={onChange}
                                                    helperText={errors.city ? errors.city.message : null}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            name="postalCode"
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    fullWidth
                                                    id="postalCode"
                                                    name="Postal Code"
                                                    inputProps={{
                                                        autoComplete: "new-password",
                                                    }}
                                                    label="Postal Code"
                                                    value={value}
                                                    error={errors.postalCode ? true : false}
                                                    onChange={onChange}
                                                    helperText={errors.postalCode ? errors.postalCode.message : null}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ marginBottom: 20 }}>
                                        <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                                        <Typography variant={"h3"}>Driver&apos;s License</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            name="dob"
                                            control={control}
                                            render={({ field: { onChange, ref, value }, formState }) => (
                                                <InputMask
                                                    alwaysShowMask={false}
                                                    formatChars={formatChars}
                                                    maskChar=" "
                                                    mask="nm/ed/zyyy"
                                                    onChange={onChange}
                                                    value={value}
                                                >
                                                    {() => (
                                                        <TextField
                                                            placeholder="DD/MM/YYYY"
                                                            label="Date Of Birth (dd/mm/yyyy)"
                                                            fullWidth
                                                            required
                                                            error={errors.dob ? true : false}
                                                            helperText={errors.dob ? errors.dob.message : null}
                                                        />
                                                    )}
                                                </InputMask>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            control={control}
                                            name="licenceNo"
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    fullWidth
                                                    required
                                                    id="licenceNo"
                                                    name="licenceNo"
                                                    label="Licence Number"
                                                    value={value}
                                                    disabled={isDisableDriverLicenceNumber}
                                                    error={errors.licenceNo ? true : false}
                                                    onChange={onChange}
                                                    helperText={errors.licenceNo ? errors.licenceNo.message : null}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            name="expiry"
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                                <>
                                                    <InputLabel shrink={!!value} htmlFor="expiry-text-field">
                                                        Date of Expiry (dd/mm/yyyy)
                                                    </InputLabel>
                                                    {isInternationalDL && <FormControlLabel
                                                        onChange={(e) => handleCheckboxChange(e, onChange)}
                                                        control={
                                                            <StyledCheckbox />

                                                        }
                                                        label={
                                                            <span style={{ fontSize: 12 }}>My Driver&apos;s License Does Not Have Expiry</span>
                                                        }
                                                        style={{ marginLeft: "0px" }}
                                                    />}
                                                    {!noExpiryChecked && <InputMask
                                                        alwaysShowMask={false}
                                                        formatChars={formatChars}
                                                        mask="dd/mm/yyyy"
                                                        maskChar=" "
                                                        onChange={(e) => onChange(e.target.value)}
                                                        value={value}
                                                    >
                                                        {(inputProps) => (
                                                            <TextField
                                                                id="expiry-text-field"
                                                                label="Date of Expiry (dd/mm/yyyy)"
                                                                fullWidth
                                                                required
                                                                value={inputProps.value}
                                                                placeholder={placeholder}
                                                                error={errors.expiry ? true : false}
                                                                helperText={errors.expiry ? errors.expiry.message : null}
                                                            />
                                                        )}
                                                    </InputMask>}
                                                </>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Controller
                                            control={control}
                                            name="regionOfIssue"
                                            render={({ field: { onChange, value } }) => (
                                                <Autocomplete
                                                    label="regionOfIssue"
                                                    disableClearable
                                                    options={options
                                                        .sort(
                                                            (a, b) => -b.countryFirstLetter.localeCompare(a.countryFirstLetter)
                                                        )
                                                        .sort()}
                                                    groupBy={(option) => option.country}
                                                    getOptionLabel={(option) => option.label}
                                                    value={value}
                                                    disabled={isDisableIssuer}
                                                    // defaultValue={options.find((element) => element.label == value)}
                                                    renderOption={(option) => option.label}
                                                    getOptionSelected={(option) => option.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            inputProps={{
                                                                autoComplete: "new-password",
                                                            }}
                                                            {...params}
                                                            fullWidth
                                                            required
                                                            label="State/Country Of Issue"
                                                            error={errors.regionOfIssue ? true : false}
                                                            helperText={
                                                                errors.regionOfIssue ? errors.regionOfIssue.message : null
                                                            }
                                                        />
                                                    )}
                                                    onChange={(_, newValue) => {
                                                        setValue("regionOfIssue", newValue);
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ marginTop: 10, position: "fixed", bottom: "20px", zIndex:"10" }}>
                                        <form>
                                            <Button
                                                style={{ borderRadius:"10px" }}
                                                fullWidth
                                                loading={checkin.loading}
                                                title={<strong>Confirm &amp; Complete Check-in</strong>}
                                                type="submit"
                                                onClick={
                                                    handleClickedSubmit(),
                                                    handleSubmit(onSubmit)}
                                            />
                                        </form>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            </ThemeProvider>
            <Dialog
                open={dialogBox}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {checkin.country == "AU"
                            ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1800 55 00 78. Please quote your driver’s licence number and reservation number."
                            : "Unfortunately your profile has been restricted, please contact our New Zealand Customer Service Team on 0800 921 460. Please quote your driver’s licence number and reservation number."}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button fullWidth onClick={handleClose} loading={checkin.loading} title={"Continue"} />
                </DialogActions>
            </Dialog>

            <Dialog
                open={expiryDateDialogBox.dialogue}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleDialogeClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    <Typography variant="h3" align="center" className={classes.wrapIcon}>
                        <WarningRounded color={"error"} fontSize={"large"} />
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.root} id="alert-dialog-slide-description">
                        {
                            "Please be aware, your current drivers licence expiry date falls within the dates of your rental period. Please make sure you arrange and present your updated licence to the rental location once it has been renewed. Failing to provide a licence that is valid for the entire period of the rental prior to pick-up will result in your booking being cancelled"
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        fullWidth
                        onClick={handleDialogeClose}
                        // loading={checkin.loading}
                        title={"Continue"}
                    />
                </DialogActions>
            </Dialog>

            <Dialog open={willExpire && !letSessionExpire}>
                <DialogTitle style={{ textAlign: "center" }}>
                    <IconButton aria-label="close" onClick={(e) => setLetSessionExpire(true)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>Your session will expire in 1 minute.</DialogContent>
                <DialogActions>
                    <Divider />
                    <Grid spacing={1} container direction="row" justify="center">
                        <Grid container item xs={12} justify="center">
                            <Fab color="primary" variant="extended" onClick={onExtendSession}>
                                Extend My Session
                            </Fab>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Dialog open={redirectToVerify}>
                <DialogTitle style={{ textAlign: "center" }}>
                    <IconButton aria-label="close" onClick={() => setRedirectToVerify(false)}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>Your personal details been changed, Click below to verify your ID.</DialogContent>
                <DialogActions>
                    <Divider />
                    <Grid spacing={1} container direction="row" justify="center">
                        <Grid container item xs={12} justify="center">
                            <Fab color="primary" variant="extended" onClick={handleConfirmRedirectToVerify}>
                                Confirm
                            </Fab>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            {reservationNumber != "" && (
                <img
                    src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g, '_')}.png?b=${reservationNumber}&a=${verifyFailed ? "2nd_driver_void_failed" : "2nd_driver_view_detail_form"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${checkin.isAdditionalDriver ? "" : "primary_driver"}`}
                    style={{ display: "none" }}
                />
            )}
        </div>)
    );
};
const useStyles = makeStyles((theme) => ({
    accordion: {
        marginLeft: 10,
        marginRight: 10,
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: "none",
        "&.Mui-expanded": {
            margin: 10,
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
    },
    headerFont: {
        color: "black",
    },
    summary: {
        backgroundColor: "#ffffff00",
        borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    groupLabel: {
        backgroundColor: "blue",
    },
    removeContainer: {
        ".pac-container:after": {
            content: "none !important",
        },
    },
    wrapIcon: {
        verticalAlign: "middle",
        display: "block",
    },
    root: {
        textAlign: "center",
        color: "red",
    },
    container: {
        position: "relative",
    },
    suggestionsContainerOpen: {
        position: "absolute",
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    suggestion: {
        display: "block",
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: "none",
    },
    divider: {
        height: theme.spacing(2),
    },
    typography: {
        color: "red",
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow:
            "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
        backgroundColor: `${theme.palette.primary.white}`,
        backgroundImage:
            "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
        "$root.Mui-focusVisible &": {
            outline: "2px auto rgba(19,124,189,.6)",
            outlineOffset: 2,
            border: `1px solid ${theme.palette.primary.darkergrey}`
        },
        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.ocean
        },
    },
    checkedIcon: {
        backgroundColor: `${theme.palette.primary.main}`,
        backgroundImage:
            "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
        "&:before": {
            display: "block",
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""'
        },
        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.ocean
        }
    },
}));

export default AdditionalDriverCheckinForm;
